import { isObject } from '@vista-digital/validator';
/**
 * Creates a new object with source properties deep merged onto the target object.
 *
 * @param target The target object to copy to.
 * @param source The source object from which to copy properties.
 */
export const deepMerge = (target, source) => {
    return Object.keys(target).reduce((acc, key) => {
        const targetValue = target[key];
        const sourceValue = acc[key];
        // Use the target property if source has nothing to merge.
        if (!(key in acc)) {
            Object.assign(acc, { [key]: targetValue });
        }
        // Deep merge nested objects.
        else if (isNonEmptyObject(targetValue) && isNonEmptyObject(sourceValue)) {
            Object.assign(acc, { [key]: deepMerge(targetValue, sourceValue) });
        }
        return acc;
    }, Object.assign({}, source));
};
/**
 * Recursively removes any undefined properties from an object.
 * @param obj the object to remove undefined properties from
 */
export const removeUndefinedValues = (obj) => {
    return Object.entries(obj)
        .map(([k, v]) => [k, v && typeof v === 'object' ? removeUndefinedValues(v) : v])
        .reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});
};
/**
 * Returns true if the value is an object with at least one property.
 */
export const isNonEmptyObject = (value) => {
    return isObject(value) && Object.keys(value).length > 0;
};
/**
 * Returns true if the value is an object with no properties.
 */
export const isEmptyObject = (value) => {
    return isObject(value) && Object.keys(value).length === 0;
};
/**
 * Returns whether the value is truthy.
 */
export const isTruthy = (value) => !!value;
//# sourceMappingURL=object-utils.js.map